module.exports = __webpack_public_path__ + "static/media/androidIcon.245acac2.svg";